<template>
    <div class="signin-wrapper d-flex align-center justify-center py-8 px-4" style="min-height: 100vh">
        <v-row style="width: 100% !important; display: flex; justify-content: center !important">
            <v-col v-show="type == 'login'" cols="12" sm="9" md="5" lg="4" class="d-flex justify-center align-center">
            <v-card class="pa-4" width="100%" max-width="400">
                <v-card-title class="d-flex justify-center">
                    <div>
                        <v-img max-height="150" max-width="200" src="img/logodam.png"></v-img>
                    </div>
                </v-card-title>
                <v-card-text class="mt-8 mt-md-15">
                    <v-form ref="login">
                        <v-row>
                            <!-- email -->
                            <v-col cols="12">
                                <v-text-field
                                    v-model="email"
                                    class="mx-auto"
                                    :disabled="loading"
                                    :label="$t('email')"
                                    outlined
                                    @keydown.enter="signin"
                                    :rules="[$rules('email')].flat()"
                                    validate-on-blur
                                />
                            </v-col>

                            <!-- password -->
                            <v-col cols="12">
                                <v-text-field
                                    v-model="password"
                                    :disabled="loading"
                                    :label="$t('password')"
                                    outlined
                                    :append-icon="showPass ? 'visibility_off' : 'visibility'"
                                    :type="showPass ? 'text' : 'password'"
                                    @click:append="showPass = !showPass"
                                    @keydown.enter="signin"
                                />

                                <!-- remember me checkbox -->
                                <div class="d-flex align-center justify-space-between flex-wrap mb-2">
                                    <v-btn text class="d-inline" @click="cambiaTipo('recovery')">{{ $t('recupera-password') }}</v-btn>
                                </div>

                                <!-- messaggio errore/validazione sopra il pulsante accedi -->
                                <v-alert v-if="message.text" :type="message.class" text dense border="left" class="mb-4">
                                    <small>{{ message.text }}</small>
                                </v-alert>

                                <!-- login button -->
                                <v-btn
                                    color="primary"
                                    block-rounded="lg"
                                    size="x-large"
                                    :disabled="!email || !password"
                                    block
                                    :loading="loading"
                                    @click="signin"
                                >
                                    {{ $t('accedi') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
            </v-col>

            <!-- disclaimer legale, mostrato solo nella schermata di login -->
            <v-col v-show="type == 'login'" cols="12" md="6" lg="5" class="d-flex align-center">
                <div class="disclaimer">
                    <div class="disclaimer__heading">
                        <v-icon class="disclaimer__icon" size="18">lock</v-icon>
                        Disclaimer
                    </div>
                    <p class="disclaimer__text" v-html="$t('disclaimer-accesso')"></p>
                </div>
            </v-col>

            <!-- ---------------------------------------------------------------------------------------------------------------
                  recupero password

            --------------------------------------------------------------------------------------------------------------- -->
            <v-card v-show="type == 'recovery'" class="pa-4 pt-7" width="100%" max-width="448">
                <v-btn @click="cambiaTipo('login')" class="ma-2" color="orange-darken-2">
                    <v-icon size="15">arrow_back</v-icon>
                    {{ $t('torna-al-log-in') }}
                </v-btn>
                <v-card-title class="justify-center">
                    <div class="d-block pa-2 b mt-10" align="center">
                        <v-img max-height="150" max-width="150" src="img/logodam.png"></v-img>
                    </div>
                </v-card-title>

                <v-card-text class="pt-2 mt-10">
                    <h5 class="text-h5 font-weight-semibold mb-1 text-center">{{ $t('recupera-password') }}</h5>
                </v-card-text>
                <v-card-text>
                    <v-form ref="forgot">
                        <v-row>
                            <!-- email -->
                            <v-col cols="12">
                                <v-text-field
                                    v-model="email"
                                    class="mt-5 mx-auto"
                                    :disabled="loading"
                                    :label="$t('email')"
                                    outlined
                                    :rules="[$rules('email')].flat()"
                                    validate-on-blur
                                />
                                <div class="d-flex justify-space-between bg-surface-variant flex-row-reverse"></div>
                            </v-col>

                            <!-- login button -->
                            <v-btn color="primary" block-rounded="lg" size="x-large" :disabled="!email" block :loading="loading" @click="forgotPassword">
                                {{ $t('invia') }}
                            </v-btn>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>

            <!-- ---------------------------------------------------------------------------------------------------------------
                  nuova password 

            --------------------------------------------------------------------------------------------------------------- -->
            <v-card v-show="type == 'new'" class="pa-4 pt-7" width="100%" max-width="448">
                <v-card-title class="justify-center">
                    <v-img max-height="150" max-width="200" src="img/logodam.png"></v-img>
                </v-card-title>

                <v-card-text class="pt-2">
                    <h5 class="text-h5 font-weight-semibold mb-1">{{ $t('nuova-password') }}</h5>
                    <v-btn @click="cambiaTipo('login')" class="ma-2" color="orange-darken-2">
                        <v-icon size="15">arrow_back</v-icon>
                        {{ $t('torna-al-log-in') }}
                    </v-btn>
                </v-card-text>
                <v-card-text>
                    <v-form>
                        <v-row>
                            <!-- PASSWORD -->
                            <v-col cols="12">
                                <v-text-field
                                    v-model="password"
                                    :disabled="loading"
                                    :label="$t('password')"
                                    outlined
                                    :append-icon="showPass ? 'visibility_off' : 'visibility'"
                                    :type="showPass ? 'text' : 'password'"
                                    @click:append="showPass = !showPass"
                                />
                            </v-col>
                            <!--CONFERMA PASSWORD -->
                            <v-col cols="12">
                                <v-text-field
                                    v-model="confPassword"
                                    :disabled="loading"
                                    :label="$t('conferma-password')"
                                    outlined
                                    :append-icon="showPass ? 'visibility_off' : 'visibility'"
                                    :type="showPass ? 'text' : 'password'"
                                    @click:append="showPass = !showPass"
                                />
                            </v-col>

                            <!-- login button -->
                            <v-btn color="primary" block-rounded="lg" size="x-large" :disabled="!password" block :loading="loading" @click="resetPassword">{{
                                $t('recupera-password')
                            }}</v-btn>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-row>
        <v-row class="d-flex align-center justify-center">
            <v-alert v-if="message.text && type !== 'login'" border="left" text dense :type="message.class" class="ma-0 mb-5">
                <small>{{ message.text }}</small>
            </v-alert>
        </v-row>
    </div>
</template>

<script>
export default {
    name: 'SignIn',
    data() {
        return {
            email: '',
            password: '',
            confPassword: '',
            code: null,
            loading: false,
            showPass: false,
            type: null,
            message: { text: null, class: 'error' }
        }
    },
    props: {
        ptype: { type: String, default: 'login' }
    },
    created() {
        this.type = this.ptype
        this.code = this.$route.query.code
    },
    methods: {
        async signin() {
            if (!this.$refs.login.validate()) {
                this.message.text = this.$t('inserire-una-email-valida')
                this.message.class = 'error'
                return
            }
            this.loading = true
            this.text = this.$t('prepariamo-la-gestione')

            try {
                await this.$auth.signIn(this.email, this.password, true)
                //logs login effettuato
                await this.$http.post(`actionlogs`, {
                    data: {
                        agent: this.$auth.utente.agent.id,
                        action: 'login',
                        lead: null,
                        date: this.$moment().format()
                    }
                })
                setTimeout(() => {
                    this.$router.push('/').catch((err) => {
                        console.log(err)
                    })
                    this.loading = false
                }, 1000)
            } catch (err) {
                console.log(err)
                this.message = {
                    text: this.$t('nome-utente-o-password-errata'),
                    class: 'error'
                }
                this.loading = false
            }
        },

        async forgotPassword(e) {
            if (!this.$refs.forgot.validate()) {
                this.message.text = this.$t('inserire-una-email-valida')
                this.message.class = 'error'
                return
            }
            this.loading = true
            this.text = this.$t('prepariamo-la-gestione')

            try {
                await this.$auth.forgotPassword(this.email)

                setTimeout(() => {
                    //success
                    this.message = {
                        text: this.$t('abbiamo-ricevuto-la-richiesta-controlla-la-casella-di-posta'),
                        class: 'success'
                    }
                    this.loading = false
                }, 1000)
            } catch (err) {
                console.log(err)
                this.message = {
                    text: this.$t('errore-riprovare'),
                    class: 'error'
                }
                this.loading = false
            }
        },
        async resetPassword(e) {
            this.loading = true

            this.text = this.$t('prepariamo-la-gestione')

            try {
                if (!this.$auth.stringEqual(this.password, this.confPassword)) {
                    //password diverse
                    this.message.text = this.$t('password-non-uguale-inserire-password-uguali')
                    this.message.class = 'error'
                    this.loading = false
                    return
                }
                if (this.password.length < 6) {
                    this.message.text = this.$t('password-troppo-corta-minimo-6-caratteri')
                    this.message.class = 'error'
                    this.loading = false
                    return
                }
                await this.$auth.resetPassword(this.password, this.confPassword, this.code)

                setTimeout(() => {
                    //success
                    this.message.text = this.$t('password-aggiornata-ritorna-al-login')
                    this.message.class = 'success'
                    this.loading = false
                }, 1000)
            } catch (err) {
                console.log(err)

                this.message = {
                    text: this.$t('errore-richiedere-nuova-mail'),
                    class: 'error'
                }
                this.loading = false
            }
        },
        cambiaTipo(nuovoTipo) {
            if (this.type == 'new' && nuovoTipo == 'login') {
                this.$router.push({ path: '/signin' }).then(() => {
                    this.$router.go()
                })
                return
            }
            this.type = nuovoTipo
            this.password = ''
            this.confPassword = ''
            this.code = ''
            this.message.text = ''
            this.message.class = ''
        }
    }
}
</script>
<style>
h5 {
    text-transform: uppercase;
}

/* pannello disclaimer accanto al form di login */
.disclaimer {
    max-width: 520px;
    padding: 28px 32px;
    background-color: #fafafa;
    border-left: 4px solid #f57c00;
    border-radius: 10px;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.06);
}

.disclaimer__heading {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 14px;
    font-size: 0.95rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #f57c00;
}

.disclaimer__icon {
    color: #f57c00 !important;
}

.disclaimer__text {
    margin: 0;
    font-size: 0.9rem;
    line-height: 1.75;
    color: #5f6368;
    text-align: justify;
}

/* i grassetti inviati via email risaltano con un colore più scuro */
.disclaimer__text strong {
    font-weight: 700;
    color: #37474f;
}

/* adattamenti per smartphone */
@media (max-width: 600px) {
    .disclaimer {
        max-width: 100%;
        padding: 20px 22px;
    }

    .disclaimer__text {
        /* in colonna stretta il giustificato crea spazi larghi tra le parole */
        text-align: left;
    }
}
</style>
